(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74716],{

/***/ 42951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/payment/index_ok",
      function () {
        return __webpack_require__(86818);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SEO = function(param) {
    var url = param.url, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "aiso, 인공지능, 인공지능 서비스, AI, machine learning"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url ? url : "https://aiso.ai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://aiso.ai/images/header/aiso_logo.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 89518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageTokenCheck; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var function_LogOut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39222);




/* 회원 비회원 token 값 체크 */ var PageTokenCheck = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(settings, router) {
        var tokenValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            if (tokenValue === "" || tokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
                // window.localStorage.removeItem("aisoToken");
                router.push("/user/market");
                ;
            } else {
                /* 만료된 토큰인지 체크해야함 */ // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch", function(error, decoded) {
                    ;
                    if (error) {
                        /* 만료된 토큰임. token 삭제하기 */ // window.localStorage.removeItem("aisoToken");
                        (0,function_LogOut__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(settings);
                        router.push("/user/market");
                    } else {
                        var email = decoded.email, name = decoded.name, uid = decoded.uid;
                        settings.login = true;
                        settings.email = email;
                        settings.name = name;
                        settings.uid = uid;
                        var setTokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign({
                            email: email,
                            name: name,
                            uid: uid
                        }, "sdkjkdlsAESRcdslkch", {
                            expiresIn: "1d"
                        });
                        window.localStorage.setItem("aisoToken", setTokenValue);
                        if (router && router.asPath === "/") {
                            router.push("/user/market");
                        } else {
                            router.push(router.asPath);
                        }
                    }
                });
            }
            return [
                2
            ];
        });
    });
    return function PageTokenCheck(settings, router) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 86818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98105);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85509);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56841);
/* harmony import */ var _Charge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36809);
/* harmony import */ var _UseCreditList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7801);
/* harmony import */ var _ChargeList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44411);
/* harmony import */ var _PaymentCredit4__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60023);
/* harmony import */ var function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89518);
/* harmony import */ var components_SEO__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68590);
/** @format */ 













//DatePicker
// import "date-fns";
/* 아임포트 테스트 */ // let IMP = window.IMP;
// var IMP = "";
// if (typeof window !== "undefined") {
//   IMP = window.IMP;
// }
var Payment = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .Pi)(function(param) {
    var headUrl = param.headUrl, headTitle = param.headTitle, headDesc = param.headDesc;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    /* 로그인 체크 : url 이동 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_9__/* .PageTokenCheck */ .C)(settings, router);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SEO__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                url: headUrl,
                title: headTitle,
                desc: headDesc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-content w-full pt-12 pb-36",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "font-bold mb-2",
                        children: "크레딧 충전/현황"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray mb-4",
                        children: "부족한 크레딧을 충전하고 사용내역,충전내역을 확인하세요"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabList, {})
                ]
            })
        ]
    });
});
var TabList = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "aiso-tab tab-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            defaultActiveKey: "credit1",
            id: "uncontrolled-tab-example",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    eventKey: "credit1",
                    title: "크레딧 충전",
                    className: "test-tab bg-white",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Charge__WEBPACK_IMPORTED_MODULE_5__["default"], {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    eventKey: "credit2",
                    title: "사용 내역",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UseCreditList__WEBPACK_IMPORTED_MODULE_6__["default"], {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    eventKey: "credit3",
                    title: "충전 내역",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ChargeList__WEBPACK_IMPORTED_MODULE_7__["default"], {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    eventKey: "credit4",
                    title: "환불 내역",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PaymentCredit4__WEBPACK_IMPORTED_MODULE_8__["default"], {})
                })
            ]
        })
    });
};
Payment.getInitialProps = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    var headTitle, headDesc, headUrl, _tmp;
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
        headTitle = "AISO PAYMENT";
        headDesc = "크레딧을 충전하여 앱을 사용하세요.";
        headUrl = "https://aiso.ai/user/payment";
        _tmp = {};
        return [
            2,
            (_tmp.headUrl = headUrl, _tmp.headTitle = headTitle, _tmp.headDesc = headDesc, _tmp)
        ];
    });
});
/* harmony default export */ __webpack_exports__["default"] = (Payment);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 53439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ forEach; },
/* harmony export */   "U": function() { return /* binding */ map; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  var index = 0;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) ? func(child, index++) : child;
  });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  var index = 0;
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(children, function (child) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) func(child, index++);
  });
}



/***/ }),

/***/ 85509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55638);
/* harmony import */ var prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types_extra_lib_isRequiredForA11y__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80789);
/* harmony import */ var _Nav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8918);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36358);
/* harmony import */ var _NavItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41244);
/* harmony import */ var _TabContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97184);
/* harmony import */ var _TabContent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28752);
/* harmony import */ var _TabPane__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67849);
/* harmony import */ var _ElementChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53439);












var defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .forEach */ .E)(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

function renderTab(child) {
  var _child$props = child.props,
      title = _child$props.title,
      eventKey = _child$props.eventKey,
      disabled = _child$props.disabled,
      tabClassName = _child$props.tabClassName,
      id = _child$props.id;

  if (title == null) {
    return null;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_NavItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    as: _NavLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    eventKey: eventKey,
    disabled: disabled,
    id: id,
    className: tabClassName
  }, title);
}

var Tabs = function Tabs(props) {
  var _useUncontrolled = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(props, {
    activeKey: 'onSelect'
  }),
      id = _useUncontrolled.id,
      onSelect = _useUncontrolled.onSelect,
      transition = _useUncontrolled.transition,
      mountOnEnter = _useUncontrolled.mountOnEnter,
      unmountOnExit = _useUncontrolled.unmountOnExit,
      children = _useUncontrolled.children,
      _useUncontrolled$acti = _useUncontrolled.activeKey,
      activeKey = _useUncontrolled$acti === void 0 ? getDefaultActiveKey(children) : _useUncontrolled$acti,
      controlledProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_useUncontrolled, ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "children", "activeKey"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: transition,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Nav__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, controlledProps, {
    role: "tablist",
    as: "nav"
  }), (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .U)(children, renderTab)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabContent__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, null, (0,_ElementChildren__WEBPACK_IMPORTED_MODULE_3__/* .map */ .U)(children, function (child) {
    var childProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, child.props);

    delete childProps.title;
    delete childProps.disabled;
    delete childProps.tabClassName;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabPane__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, childProps);
  })));
};

Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';
/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34619,52387,94924,33426,27680,99320,57333,88920,46579,44411,36809,7801,60023,49774,92888,40179], function() { return __webpack_exec__(42951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);